import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { ContextService } from './context.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private keycloakService: KeycloakService,
    private contextService:ContextService
  ) {}

  async logout() {
    this.contextService.clear();
    await this.keycloakService.logout(window.location.origin);
  }

  getTokenParsed(): any {
    return this.keycloakService.getKeycloakInstance().tokenParsed;
  }

  getOwnership(): any {
    return this.contextService.getHeaderValues()?.actorCode;
  }

  get userInfo() {
    const tokenParsed = this.getTokenParsed();
    return {
      name: tokenParsed?.name || '',
      email: tokenParsed?.email || '',
      username: tokenParsed?.preferred_username || '',
      roles: tokenParsed?.realm_access?.roles || [],
      group: tokenParsed?.group || '',
    };
  }

  private hasRole(role: string): boolean {
    return this.contextService.getRole() == role;
  }

  get isOperatoreUvm(): boolean {
    return this.hasRole('OPERATORE_UVM');
  }

  get isOperatoreSuperUser(): boolean {
    return this.userInfo.roles.includes('SUPERUSER');
  }

  get isOperatoreUvcp(): boolean {
    return this.hasRole('OPERATORE_UVCP');
  }

  get isOperatorePua(): boolean {
    return this.hasRole('OPERATORE_PUA');
  }

  get isOperatoreBM(): boolean {
    return this.hasRole('OPERATORE_BM');
  }

  get isOperatoreCot(): boolean {
    return this.hasRole('OPERATORE_COT');
  }

  get isOperatoreSegnalante(): boolean {
    return this.hasRole('OPERATORE_SEGNALANTE');
  }

  get isOperatoreMmg(): boolean {
    return this.hasRole('OPERATORE_MMG');
  }

  get isAdmin(): boolean {
    return this.hasRole('ADMIN');
  }

  get isLoggedIn(): boolean {
    return this.keycloakService.isLoggedIn();
  }

  // hasAnyRole(roles: string[]): boolean {
  //   return roles.some((role) => this.userInfo.roles.includes(role));
  // }
}
